import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/class-operations', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/class-operations', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/class-operations/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/class-operations/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/class-operations/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getYear = (Options = {}) => {
  return httpClient
    .get(
      '/api/academic-years?fields[academic_years]=ac_year_id,ac_year,ac_status_id&filter[ac_status_id]=1,3&page=-1'
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.data))
}

export const getTerm = (Options = {}) => {
  return httpClient
    .get(
      '/api/term-semesters?fields[academic_terms]=ac_term_id,term_name,ac_year_id,acps_id,ac_status_id&filter[ac_status_id]=1,3&page=-1'
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.data))
}

//Get main and sub program by filter term
export const getMainAndSub = (acps_id, Options = {}) => {
  return httpClient
    .get(
      `/api/sub-programs?filter[acps_id]=${acps_id}&fields[mainProgram]=acp_id,acp_name_native,acp_name_foreign&include=main_program&page=-1`
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.data))
}

// Get level and grade base on sub promgram
export const getLevel = (acps_id, Options = {}) => {
  return httpClient
    .get(
      `/api/levels?fields[academic_program_levels]=level_id,level_name_native,level_name_foreign&include=grades&filter[acps_id]=${acps_id}&page=-1`
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.data))
}

//Get teacher list
export const getTeacher = (Options = {}) => {
  return httpClient
    .get(
      `/api/teacher-profiles?fields[setup_teacher_profiles]=teacher_id,fname_foreign,lname_foreign&page=-1`
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.data))
}

// Get building list
export const getBuilding = (Options = {}) => {
  return httpClient
    .get(
      `/api/buildings?fields[setup_building]=building_id,building_name&fields[rooms]=building_id,room_id,room_name&include=rooms&page=-1`
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.data))
}

// Get study time
export const getStudyTime = (Options = {}) => {
  return httpClient
    .get(
      `/api/study-times?fields[academic_study_times]=ac_st_id,study_time&page=-1`
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.data))
}

// Get academic class category
export const getCategoryClass = (Options = {}) => {
  return httpClient
    .get(`/api/class-operations/class/categories`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.data))
}

// Get list own class
export const getListClass = (Options = {}) => {
  return httpClient
    .get(
      `/api/class-operations?fields[academic_classes]=ac_year_id,ac_term_id,class_id,class_name&include=academic_year,academic_term&page=-1&allYear=1`
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.data))
}

// get class list allow student to swap class
export const getClassAllowSwap = (acps_id, Options = {}) => {
  return httpClient
    .get(
      `/api/class-operations?fields[academic_classes]=class_id,class_name,acps_id&filter[acps_id]=${acps_id}&page=-1`
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.data))
}

export const copyClass = data => {
  return httpClient
    .post('/api/class-operations/copy-class', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const formViewModel = (Options = {}) => {
  return httpClient
    .get('/api/class-operations/form-view-models', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  getYear,
  getTerm,
  getMainAndSub,
  getLevel,
  getTeacher,
  getBuilding,
  getStudyTime,
  getCategoryClass,
  getListClass,
  getClassAllowSwap,
  copyClass,
  formViewModel
}
